<template>
  <div class="main">
    <div class="card">
      <div class="title">
        <div class="line"></div>
        <span>基本信息</span>
      </div>
      <div class="info">
        <div class="columns">
          <div class="label">安装位置：</div>
          <div class="value">{{ deviceName }}</div>
        </div>
        <div class="columns">
          <div class="label">安装坐标：</div>
          <div class="value">26.618359,106.752559</div>
        </div>
        <div class="columns">
          <div class="label">持续时间：</div>
          <div class="value">1天</div>
        </div>
        <div class="columns">
          <div class="label">安装部位：</div>
          <div class="value">{{ deviceName }}</div>
        </div>
        <div class="columns">
          <div class="label">管道材质：</div>
          <div class="value">球墨铸铁</div>
        </div>
        <div class="columns">
          <div class="label">安装深度：</div>
          <div class="value">{{ deep }}m</div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="title">
        <div class="line"></div>
        <span>音频信息</span>
      </div>
      <div id="audio" style="width: 100%; height: 450px;"></div>
    </div>
    <div class="card">
      <div class="title">
        <div class="line"></div>
        <span>预警分布</span>
      </div>
      <div id="warning" style="width: 100%; height: 450px;"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      chart: null,
      chart1: null,
      deviceName: '',
      deep: '',
      warningData: {
        xData: ["2025-10-05","2025-10-06", "2025-10-07","2025-10-08","2025-10-09", "2025-10-10", "2025-10-11"],
        yData: [5, 20, 36, 10, 22, 31, 15],
      }
    };
  },
  created () {
    const id = this.$route.query.id;
    switch (id) {
      case '1':
        this.deviceName = '遵义医科大学附属医院A区';
        this.deep = 1.1;
        break;
      case '2':
        this.deviceName = '遵义医科大学附属医院B区';
        this.deep = 1.3;
        break;
      case '3':
        this.deviceName = '遵义医科大学附属医院C区';
        this.deep = 0.9;
        break;
      case '4':
        this.deviceName = '遵义医科大学附属医院D区';
        this.deep = 1.2;
      case '5':
        this.deviceName = '遵义医科大学附属医院A区1号点位';
        this.deep = 1.1;
        break;
      case '6':
        this.deviceName = '遵义医科大学附属医院A区2号点位';
        this.deep = 1.3;
        break;
      case '7':
        this.deviceName = '遵义医科大学附属医院A区3号点位';
        this.deep = 0.9;
        break;
      case '8':
        this.deviceName = '遵义医科大学附属医院B区1号点位';
        this.deep = 1.2;
      case '9':
        this.deviceName = '遵义医科大学附属医院B区2号点位';
        this.deep = 1.1;
        break;
      case '10':
        this.deviceName = '遵义医科大学附属医院C区1号点位';
        this.deep = 1.3;
        break;
      case '11':
        this.deviceName = '遵义医科大学附属医院C区2号点位';
        this.deep = 0.9;
        break;
      case '12':
        this.deviceName = '遵义医科大学附属医院C区3号点位';
        this.deep = 1.2;
      case '13':
        this.deviceName = '遵义医科大学附属医院D区1号点位';
        this.deep = 0.9;
        break;
      case '14':
        this.deviceName = '遵义医科大学附属医院D区2号点位';
        this.deep = 1.2;
        break;
      default:
        break;
    }
  },
  mounted() {
    const audioData = {
      randomNumbers: [],
      date: []
    }
    for (let i = 0; i < 24; i++) {
      // 生成0到400之间的随机整数
      const randomNum = Math.floor(Math.random() * 401);
      // 将随机数添加到数组中
      audioData.randomNumbers.push(randomNum);
      let time = i < 10 ? '0' + i + ':' + '00' : i + ':' + '00';
      audioData.date.push(time);
    }
    this.$nextTick(() => {
      this.initChart(audioData);
    })
    this.initChart2(this.warningData);
  },
  methods: {
    initChart(datas) {
      this.chart = echarts.init(document.getElementById("audio"));
      this.setOptions(datas);
    },
    setOptions(datas) {
      const colorList = ["#9E87FF", "#73DDFF", "#fe9a8b", "#F56948", "#9E87FF"];
      var option = {
        backgroundColor: "#fff",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              show: true,
              backgroundColor: "#fff",
              color: "#556677",
              borderColor: "rgba(0,0,0,0)",
              shadowColor: "rgba(0,0,0,0)",
              shadowOffsetY: 0
            },
            lineStyle: {
              width: 0
            }
          },
          backgroundColor: "#fff",
          textStyle: {
            color: "#5c6c7c"
          },
          padding: [10, 10],
          extraCssText: "box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)"
        },
        grid: {
          top: "15%"
        },
        xAxis: [
          {
            type: "category",
            data: datas.date,
            axisLine: {
              lineStyle: {
                color: "#DCE2E8"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#556677"
              },
              // 默认x轴字体大小
              fontSize: 12,
              // margin:文字到x轴的距离
              margin: 15
            },
            // boundaryGap: false,
            splitLine: {
              show: false,
              lineStyle: {
                color: ["#66FFFF"]
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#DDD"
              }
            },
            show: true,
            name: "Hz",
            nameTextStyle: {
              color: "#788593"
            },
          }
        ],
        series: [
          {
            name: "噪音",
            type: "line",
            data: datas.randomNumbers,
            symbolSize: 1,
            symbol: "circle",
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "#0E5FFF"
                },
                {
                  offset: 1,
                  color: "#00F2EF"
                }
              ]),
              shadowColor: "rgba(158,135,255, 0.3)",
              shadowBlur: 10,
              shadowOffsetY: 20
            },
            itemStyle: {
              normal: {
                color: colorList[0],
                borderColor: colorList[0]
              }
            }
          }
        ]
      };
      this.chart.setOption(option);
      window.addEventListener("resize", function() {
        this.chart.resize();
      });
    },
    initChart2(datas) {
      this.chart1 = echarts.init(document.getElementById("warning"));
      this.setOptions2(datas);
    },
    setOptions2(datas) {
      const data = datas.yData;
      const dataX = datas.xData;
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          formatter: function(params) {
            return (
              params[0].name +
              "<br/>" +
              params[0].seriesName +
              " : " +
              params[0].value 
              // "次"
            );
          }
        },
        xAxis: {
          data: dataX
        },
        yAxis: {},
        series: [
          {
            name: "预警",
            type: "bar",
            data: data,
            type: "bar",
            barWidth: "40%",
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#00F0FF"
                  },
                  {
                    offset: 1,
                    color: "#0066FF"
                  }
                ]
              },
              borderRadius: [2, 2, 0, 0]
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
              fontSize: 12
            }
          }
        ]
      };
      this.chart1.setOption(option);
      window.addEventListener("resize", function() {
        this.chart1.resize();
      });
    }
  }
};
</script>

<style scoped>
.main {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.main .card {
  width: 100%;
  margin-bottom: 20px;
}
.main .card .title {
  width: 100%;
  display: flex;
  align-items: center;
}
.main .card .title .line {
  width: 4px;
  height: 16px;
  background: #1890ff;
  border-radius: 2px;
  margin-right: 5px;
}
.main .card .title span {
  font-size: 16px;
  font-weight: 600;
}
.main .card .info {
  width: 100%;
}
.main .card .info .columns {
  width: 100%;
  padding: 10px 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.main .card .info .columns .value {
  color: #666666;
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/noise/index.vue